import { PhoneNumber } from "@/services/phone.services";

export function liveNumberFindCb(phoneNumber: PhoneNumber) {
  return phoneNumber.callable;
}
